function onError( e ) {

	const element = this;
	const fallbackSrc = element.dataset.fallbackSrc;

	if ( element.src !== fallbackSrc ) {

		element.src = fallbackSrc;

	}

	if ( fallbackSrc == '' || fallbackSrc == null ) {
		element.removeEventListener( 'error', onError, false );
	}

}

export function initializeFallbackSrc() {

	const images = document.querySelectorAll( '[data-fallback-src]' );
	
	for ( let image of images ) {

		image.addEventListener( 'error', onError, false );

	}

}